module.exports = __webpack_public_path__ + "static/media/12WEB.9855980d.png";